<div class="document-viewer-container">
  <!-- Header -->
  <div class="document-viewer-header">
    <div class="document-info">
      <mat-icon class="file-icon">{{ getFileIcon() }}</mat-icon>
      <div class="document-details">
        <h2 class="document-title">{{ document.name }}</h2>
        <div class="document-meta">
          @if (document.fileSize) {
            <span class="filesize">{{ getFileSizeFormatted() }}</span>
          }
        </div>
      </div>
    </div>

    <div class="document-actions">
      <button
        mat-icon-button
        matTooltip="Download"
        (click)="download()"
        [disabled]="loading || error"
      >
        <mat-icon>download</mat-icon>
      </button>
      <button
        mat-icon-button
        matTooltip="Close"
        (click)="close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Content Area -->
  <div class="document-viewer-content">
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="50" />
        <p>Loading document...</p>
      </div>
    } @else if (error) {
      <div class="error-container">
        <mat-icon class="error-icon">error</mat-icon>
        <h3>Failed to Load Document</h3>
        <p>{{ errorMessage }}</p>
        <button mat-button (click)="loadDocumentContent()">
          <mat-icon>refresh</mat-icon>
          Try Again
        </button>
      </div>
    } @else {
      @if (fileType === 'pdf') {
        <div class="pdf-container">
          <iframe
            [src]="fileUrl"
            class="pdf-viewer"
            frameborder="0"
            title="PDF Viewer"
          ></iframe>
        </div>
      } @else if (fileType === 'image') {
        <div class="image-container">
          <img
            [src]="fileUrl"
            [alt]="document.name"
            class="image-viewer"
            (error)="error = true; errorMessage = 'Failed to load image'"
          />
        </div>
      } @else {
        <div class="unsupported-container">
          <mat-icon class="unsupported-icon">description</mat-icon>
          <h3>Unsupported File Type</h3>
          <p>This file type cannot be previewed in the browser.</p>
          <button mat-raised-button color="primary" (click)="download()">
            <mat-icon>download</mat-icon>
            Download File
          </button>
        </div>
      }
    }
  </div>

  <!-- Footer -->
  @if (!loading && !error) {
    <div class="document-viewer-footer">
      <div class="footer-info">
        @if (document.name) {
          <span class="description">{{ document.name }}</span>
        }
      </div>
      <div class="footer-actions">
        <button mat-button (click)="close()"><span i18n="@@buttonClose">Close</span></button>
        <button mat-raised-button color="primary" (click)="download()">
          <mat-icon>download</mat-icon>
          <span i18n>Download</span>
        </button>
      </div>
    </div>
  }
</div>
